<docs>
## YuAmount Docs
</docs>

<template>
  <transition>
    <div class="yu-amount" data-com="YuAmount">
      <YuButton class="yu-amount-btn yu-amount-minus" :disabled="nVal === min" @click="fnMinus">
        <YuIcon name="minus" slot="icon" />
      </YuButton>
      <input :key="mark" class="yu-amount-ipt" type="number" :value="nVal" @change="fnChange" :min="min" :max="max" />
      <YuButton class="yu-amount-btn yu-amount-add" :disabled="nVal >= max" @click="fnAdd">
        <YuIcon name="add" slot="icon" />
      </YuButton>
    </div>
  </transition>
</template>

<script>
  export default {
    componentName: 'YuAmount',
    props: {
      value: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: 999999
      },
      min: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        mark: true,
        nVal: this.value || 0
      }
    },
    watch: {
      value (val) {
        this.nVal = val
      }
    },
    methods: {
      setNum (val) {
        this.nVal = val
        this.$emit('input', val)
      },
      fnChange (evt) {
        const _val = parseInt(evt.target.value)
        if (_val > 0) {
          this.setNum(_val)
        } else {
          // 防止空输入不刷新视图
          this.mark = !this.mark
        }
      },
      fnAdd () {
        if (this.nVal < this.max) {
          this.setNum(this.nVal + 1)
        }
      },
      fnMinus () {
        if (this.nVal > this.min) {
          this.setNum(this.nVal - 1)
        }
      }
    }
  }
</script>

<style>
  .yu-amount {
    display: inline-flex;
  }
  .yu-amount-ipt {
    display: inline-block;
    flex: 1;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    padding: 0;
    border: 0 solid #d5d5d5;
    border-width: .5px 0;
    border-radius: 0;
    width: 3em;
    font-size: 12px;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
  }
  .yu-amount-btn {
    padding: 5px 6px;
    border: 0 solid #d5d5d5;
    font-size: 12px;
    color: #999;
    transition: background-color .3s ease-out;
  }
  .yu-amount-btn:active {
    color: #999;
    border-color: #d5d5d5;
    background-color: #eee;
    transition: none;
  }
  .yu-amount-btn.is-disabled {
    color: #ddd;
    background-color: transparent;
    border-color: #d5d5d5;
  }
  .yu-amount-btn.is-disabled:active {
    color: #ddd;
    background-color: transparent;
    border-color: #d5d5d5;
  }
  .yu-amount-minus {
    border-width: .5px 0 .5px .5px;
    border-radius: 3px 0 0 3px;
  }
  .yu-amount-add {
    border-width: .5px .5px .5px 0;
    border-radius: 0 3px 3px 0;
  }
</style>



// WEBPACK FOOTER //
// Amount.vue?799c26ec